import React, { FunctionComponent, useContext, useState } from "react";
import { County, ActionType } from "../../@types";
import { AppStore } from "../../app/store";
import { Continue, CountyPicker } from "../../components";
import { useTranslate } from "../../helpers";
import routes from "../../app/routes";

interface LearnMoreProps {
  fips?: string;
  zip?: string;
}

const LearnMore: FunctionComponent<LearnMoreProps> = ({ fips, zip }) => {
  const t = useTranslate();
  const { dispatch } = useContext(AppStore.AppContext);
  const [county, setCounty] = useState<County | null>(null);

  const handleCountySelected = (newCounty?: County, zipCode?: string): void => {
    if (newCounty) {
      setCounty(newCounty);
      dispatch({ type: ActionType.UPDATE_COUNTY, payload: newCounty });
      dispatch({ type: ActionType.UPDATE_FIPS, payload: newCounty.fips });
    }

    if (zipCode) {
      dispatch({ type: ActionType.UPDATE_ZIPCODE, payload: zipCode });
    }
  };

  return (
    <div className="ds-u-margin-top--5">
      <CountyPicker
        label={t("plan_search.enter_your_zip_code")}
        onCountySelect={handleCountySelected}
        initialFips={fips}
        initialZip={zip}
      />

      {county && <Continue useLink to={`#${routes.coverageWizard.options}`} />}
    </div>
  );
};

export default LearnMore;
